import gql from 'graphql-tag'

export const GET_COLOR_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getColorPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        code
        texture
      }
    }
  }
`

export const GET_COLOR_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getColor (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      code
      isTexture
      texture
    }
  }
`
